module.exports = __webpack_public_path__ + "static/media/Arrowwithcircle.b83a162c.svg";